import { jsx } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { CardButtonImpl } from "./card-button.styles.es.js";
const propTypes = {
  as: PropTypes.elementType,
  children: PropTypes.node
};
const defaultProps = {
  as: void 0,
  children: void 0
};
const CardButton = ({ as, children, ...restProps }) => /* @__PURE__ */ jsx(CardButtonImpl, { as, ...restProps, children });
CardButton.propTypes = propTypes;
CardButton.defaultProps = defaultProps;
export {
  CardButton
};
